import React from "react";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Validators from "@app/utilities/validators";
import Loader from "@components/common/Loader";

interface IPortalLinkFormComp {
  name: string;
  className?: string;
  isLoading?: boolean;
  onSubmit: (data: { [key: string]: any }, evt?: React.BaseSyntheticEvent) => Promise<boolean>;
  onError?: (errors: { [key: string]: any }, evt?: React.BaseSyntheticEvent) => any;
}

const PortalLinkFormComp: React.FC<IPortalLinkFormComp> = (props) => {
  const { name, className: extClassName, isLoading, onSubmit, onError } = props,
    { register, handleSubmit, formState } = useForm<{
      email: string;
    }>({
      defaultValues: {},
      mode: "onChange",
      reValidateMode: "onSubmit",
      shouldUnregister: false,
      shouldFocusError: true,
      delayError: undefined,
    }),
    fieldErrors = formState.errors,
    isDirty = formState.isDirty,
    isValid = formState.isValid,
    classes = classNames(extClassName);

  const emailRegs = register("email", Validators.email);

  return (
    <form name={name} className={classes} onSubmit={handleSubmit(onSubmit, onError)}>
      <div className="form-group">
        <label className="text-azure" htmlFor="email">
          Email address
        </label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="john.doe@gmail.com"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          autoFocus={true}
          className={classNames("form-control", {
            invalid: !!fieldErrors["email"],
          })}
          {...(!!fieldErrors["email"] && { "aria-describedby": "emailTip" })}
          {...emailRegs}
        />
        {!!fieldErrors["email"] && (
          <small id="emailTip" className="form-text text-warning mt-2 mb-5">
            {fieldErrors["email"]?.message || "Invalid email address"}
          </small>
        )}
      </div>
      <button
        className="btn btn-main btn-block py-3 mt-5"
        type="submit"
        {...((!isDirty || !isValid || isLoading) && {
          disabled: true,
          "aria-disabled": true,
        })}
      >
        <strong>{isLoading ? <Loader size={1} /> : "EMAIL ME A LINK"}</strong>
      </button>
    </form>
  );
};

export default PortalLinkFormComp;
